import gql from 'graphql-tag'

// export const INSERT_PRODUCT_BATCHES = gql`
// mutation insert_ProductBatches($id:uuid,$batch:String!,$qtyIn:Int!,$qtyOut:Int!, $currentQty:Int!,$createdBy:uuid! ){
//   insert_ProductBatches(objects: {id:$id,batch:$batch,qtyIn:$qtyIn,qtyOut:$qtyOut,currentQty:$currentQty,createdBy:$createdBy })
//   {returning{
//   id
//   }}
//   }
// `
export const INSERT_PRODUCT_BATCHES = gql`
mutation insert_BatchTable($id:uuid,$productId:uuid!,$sku:String!,$batch:String!,$noOfItems:Int!,$ownedBy:uuid!,$ownedDate:date!, $status:String!,$createdBy:uuid! ){
  insert_BatchTable(objects: {id:$id,productId:$productId,sku:$sku,batch:$batch,noOfItems:$noOfItems,ownedBy:$ownedBy,ownedDate:$ownedDate,status:$status, createdBy:$createdBy })
  {returning{
  id
  }}
  }
`

export const INSERT_PRODUCT_INVENTORY = gql`
mutation insert_ProductInventory($id:uuid,$sku:String!, $productId:uuid!, $batchId:uuid!,$serial:String!,$status:String!,$ownedBy:uuid!,$ownedDate:timestamptz!, $createdBy:uuid!){
  insert_ProductInventory(objects: {id:$id, sku:$sku, productId:$productId, batchId:$batchId, serial:$serial,status:$status, ownedBy:$ownedBy,ownedDate:$ownedDate,createdBy:$createdBy })
  {returning{
  id
  }}
}
`


export const INSERT_ORDERS = gql`
mutation insert_Orders($id:uuid!,$date:timestamptz, $from:uuid!, $to:uuid!, $lineItemCounts:Int!,$status:String!,$placedBy:uuid!,$notes:String!,$invoiceNote:String!,$invoiceNumber:String!,$invoiceDate:date, $orderType:Int!){
  insert_Orders(objects: {id:$id, date:$date, from:$from,to:$to, lineItemCounts:$lineItemCounts, status:$status,placedBy:$placedBy,notes:$notes,invoiceNote:$invoiceNote,invoiceNumber:$invoiceNumber,invoiceDate:$invoiceDate, orderType:$orderType })

  {returning{
  id
  }}
}
`
// export const INSERT_ORDER_ITEMS = gql`
// mutation insert_OrderItems($id:uuid!,$orderId:uuid!,$productId:uuid!,$qty:Int!,$notes:String!,$inventoryIds:jsonb!){
//   insert_OrderItems(objects:{id:$id, orderId:$orderId, productId:$productId, qty:$qty,notes:$notes,inventoryIds:$inventoryIds})
//   {  returning{id}
//   }
// }
// `
export const INSERT_ORDER_ITEMS = gql`
mutation insert_OrderItems($id:uuid!,$orderId:uuid!,$productId:uuid!,$qty:Int!,$notes:String!,$to:uuid!,$from:uuid!,$sellType:String!,$batchId:uuid!,$productInventoryId:uuid,$status:String!, $meta:jsonb){
  insert_OrderItems(objects:{id:$id, orderId:$orderId, productId:$productId, qty:$qty,notes:$notes,to:$to,from:$from,sellType:$sellType,batchId:$batchId,productInventoryId:$productInventoryId,status:$status, meta:$meta})
  {  returning{id}
  }
}
`
export const UPDATE_PROODUCT_INVENTORY = gql`
mutation update_ProductInventory($serials:[String!],$ownedBy:uuid!,$ownedDate:timestamptz!){
  update_ProductInventory(where:{serial: {_in:$serials}}
  _set:{ownedBy:$ownedBy, ownedDate:$ownedDate}){
  returning{
  id
  }}
 }
`

export const INSERT_ORDER_AND_MULTIPLE_ORDER_ITEMS = gql`
mutation insert_Orders($orderObj: [Orders_insert_input!]!){
  insert_Orders(objects: $orderObj) {
    returning{id}
  }
}
`
